import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "256",
  height: "256",
  fill: "currentColor",
  viewBox: "0 0 200 200"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<g transform=\"rotate(-30 100 100)\"><circle cx=\"58\" cy=\"62\" r=\"22\"></circle><circle cx=\"46\" cy=\"78\" r=\"20\"></circle><circle cx=\"142\" cy=\"138\" r=\"22\"></circle><circle cx=\"154\" cy=\"122\" r=\"20\"></circle><path d=\"m73.627 61.68 72.746 42-20 34.64-72.746-42z\"></path></g>", 1)
  ]))]))
}
export default { render: render }